import { render } from "./ManageRoomView.vue?vue&type=template&id=0156dc2a&scoped=true"
import script from "./ManageRoomView.vue?vue&type=script&lang=js"
export * from "./ManageRoomView.vue?vue&type=script&lang=js"

import "./ManageRoomView.vue?vue&type=style&index=0&id=0156dc2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0156dc2a"]])

export default __exports__